export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4737.56f25935.jpg";